import Swiper from 'swiper';
import { Pagination, Autoplay, Controller } from 'swiper/modules';

function featuredSlider() {
  const featuredSliderText =  document.querySelector('[data-target="featured-slider-text"]');

  if ( ! featuredSliderText ) return;

  const sliderText = new Swiper('[data-target="featured-slider-text"]', {
		modules: [Pagination, Autoplay, Controller],
		loop: true,
		draggable: true,
		allowTouchMove: true,
		effect: 'fade',
		spaceBetween: 20,
		slidesPerView: 1,

		pagination: {
			el: '.featured-pagination',
			type: 'bullets',  // bullets, fraction (ex. 1/10), progressbar
			clickable: true,
		},
	});

  const sliderImage = new Swiper('[data-target="featured-slider-image"]', {
		modules: [ Autoplay, Controller],
		loop: true,
		draggable: true,
		allowTouchMove: true,
		effect: 'fade',
		spaceBetween: 20,
		slidesPerView: 1,
	});


  sliderText.controller.control = sliderImage;
  sliderImage.controller.control = sliderText;

}

export default featuredSlider;